class ExpertHelp {
  constructor() {

    if(document.querySelector('.expert-help') != null && document.querySelector('.expert-help') != undefined) {
      this.setEvents();
    }

  }
  
  setEvents() {
    
    //textarea ---------------------------------------------------------------------------------

    var comment = document.querySelector('.expert__comment');

    var textarea = comment.querySelector('textarea');
    var maxLength = textarea.getAttribute('maxLength');
    var counter = comment.querySelector('.counter');

    textarea.addEventListener("keyup", function() {
      var text = textarea.value.length;
      counter.textContent = (maxLength - text);
    });

    //Changes ---------------------------------------------------------------------------------

    var change_btns = document.querySelectorAll('.expert__change-btn');

    change_btns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        btn.parentNode.classList.add('changing');
      });
    });

    var change = document.querySelectorAll('.expert__change');

    change.forEach(c => {
      var save_btn = c.querySelector('.save');
      save_btn.addEventListener('click', function(e) {
        e.preventDefault();
        c.parentNode.classList.remove('changing');
      });

      var cancel_btn = c.querySelector('.cancel');
      cancel_btn.addEventListener('click', function(e) {
        e.preventDefault();
        c.parentNode.classList.remove('changing');
      });
    });

  }
    
}

$(document).ready(function() {
  const expertHelp = new ExpertHelp();
});
